"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.setPIISelectors = exports.initClickTale = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

/**
 * Enable ClickTale telemetry integration
 * @param partition The ClickTale partition id
 * @param projectID The ClickTale project id
 */
var initClickTale = function initClickTale(partition, projectID) {
  var _context;

  var piiSelectors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var win = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window;
  var scriptElement = win.document.createElement('script');
  scriptElement.type = 'text/javascript';
  var scrSrc = win.document.location.protocol === 'https:' ? 'https://cdnssl.Clicktale.net/' : 'http://cdn.Clicktale.net/';
  scrSrc += (0, _concat.default)(_context = "www".concat(partition, "/ptc/")).call(_context, projectID, ".js");
  scriptElement.src = scrSrc;
  win.document.body.appendChild(scriptElement);
  setPIISelectors(piiSelectors);
};

exports.initClickTale = initClickTale;

var setPIISelectors = function setPIISelectors(piiSelectors) {
  var _context2;

  var win = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  // Set some default pii selectors
  win.ClickTalePIISelector = (0, _concat.default)(_context2 = ['.ms-pii', '.ms-Persona', '.ms-Persona .ms-Image-image', '.ms-Persona-initials', '.ms-Persona-initials > span', '.ms-Persona-secondaryText', '.ms-Persona-primaryText', '.ms-Persona-tertiaryText', '.ms-Persona-optionalText', '.ms-TooltipHost', '.ms-Dialog-subText', '.ms-PeoplePicker', '.ms-tenantName']).call(_context2, piiSelectors).join(', ');
};

exports.setPIISelectors = setPIISelectors;